import { render, staticRenderFns } from "./HtVideoPlayer.vue?vue&type=template&id=1565159c&scoped=true&"
import script from "./HtVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./HtVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./HtVideoPlayer.vue?vue&type=style&index=0&id=1565159c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565159c",
  null
  
)

export default component.exports